import Container from 'typedi';
import IHTTPClientAdapter from '../adapters/HTTPClientAdapter/IHTTPClientAdapter';
import LogService from '../services/LogService';

class PlanificationRepository {
  httpClientAdapter;
  lastmileApiUrl;
  logService;
  constructor() {
    this.httpClientAdapter = Container.get(IHTTPClientAdapter);
    this.lastmileApiUrl = Container.get('ENV_LASTMILE_API_URL');
    this.logService = Container.get(LogService);
  }
  async getPlanifications(page, rowsPerPage, filters) {
    try {
      let baseUrl = `${this.lastmileApiUrl}/planification?pageNum=${page}&pageSize=${rowsPerPage}`;
      let filtersArray = [];
      if (filters) {
        if (filters.startDate) {
          filtersArray.push(`startDate=${filters.startDate}`);
        }
        if (filters.endDate) {
          filtersArray.push(`endDate=${filters.endDate}`);
        }
        if (filters.deepLevel) {
          filtersArray.push(`deepLevel=${filters.deepLevel}`);
        }
        if (filters.idOrigin) {
          filtersArray.push(`idOrigin=${filters.idOrigin.id}`);
        }
        if (filters.idDestination) {
          filtersArray.push(`idDestination=${filters.idDestination.id}`);
        }
        if (filters.planificationState && filters.planificationState.length > 0) {
          for (const status of filters.planificationState) {
            filtersArray.push(`planificationState=${status.id}`);
          }
        }
        if (filters.routeState && filters.routeState.length > 0) {
          for (const status of filters.routeState) {
            filtersArray.push(`routeState=${status.id}`);
          }
        }
        if (filters.planificationName) {
          filtersArray.push(`planificationName=${filters.planificationName}`);
        }
        if (filters.documentNumber) {
          filtersArray.push(`numberDocument=${filters.documentNumber}`);
        }
        if (filters.planificationId) {
          filtersArray.push(`idPlanification=${filters.planificationId}`);
        }
        if (filters.driver && filters.driver.length > 0) {
          for (const driver of filters.driver) {
            filtersArray.push(`idDriver=${driver.id}`);
          }
        }
        if (filters.vehicle && filters.vehicle.length > 0) {
          for (const vehicle of filters.vehicle) {
            filtersArray.push(`idVehicle=${vehicle.id}`);
          }
        }
      }
      const filterQuery = filtersArray.join('&');
      const url = baseUrl + (filterQuery.length ? `&${filterQuery}` : '');
      this.logService.sendInfo({
        component: "planificationRepository",
        message: "getPlanifications solicitando la siguiente url al back " + url,
      });
      const clientId = Container.get('clientId');
      const accessToken = Container.get('accessToken');
      console.log(url);
      const config = {
        headers: {
          'id-client': clientId,
          Authorization: `Bearer ${accessToken}`,
        }
      };
      return await this.httpClientAdapter.get(url, config);
    } catch (e) {
      console.log(e);
      return {
        data: [],
        paginator: {
          totalRows: 0,
        },
      };
    }
  }
  async getPlanificationsDashboard() {
    try {
      const url = `${this.lastmileApiUrl}/routeboard`;
      const clientId = Container.get('clientId');
      const accessToken = Container.get('accessToken');
      console.log(url);
      const config = {
        headers: {
          'id-client': clientId,
          Authorization: `Bearer ${accessToken}`,
        },
        responseType: 'arraybuffer',
      };
      const response = await this.httpClientAdapter.get(url, config);
      const pako = require('pako');
      if (response.status === 200) {
        const inflate = pako.inflate(response.data, { to: 'string' });
        return JSON.parse(inflate);
      }
      return [];
    } catch (e) {
      console.log(e);
      return {
        data: [],
        paginator: {
          totalRows: 0,
        },
      };
    }
  }
}

Container.set({ id: PlanificationRepository, type: PlanificationRepository });

export default PlanificationRepository;
